export const AbandonCartAction = {
  CLEAR: 0,
  DISMISS: 1,
  CHECKOUT: 2,
};

export const AbandonCartType = {
  ABANDON: 'abandon',
  PERSISTANT: 'persistant',
};
